import type { Router, RouteLocationNormalized } from "vue-router"

const routerHistories: RouteLocationNormalized[] = []
let examResultPreviusNameMap: string[] = []

export function setupExamRouterHistories(
  item: Router,
  examPreviusNameMap: string[]
) {
  examResultPreviusNameMap = [...examResultPreviusNameMap, ...examPreviusNameMap]
  item.afterEach((_, from) => {
    routerHistories.push(from)
  })
}

/**
 * Get the last route that matches the examResultPreviusNameMap
 * @param excludeNames - Optional array of route names to exclude from the search
 */
export function getLastExamRoute(excludeNames?: string[]) {
  if (examResultPreviusNameMap.length == 0) {
    throw new Error("setupRouterHistories not setup")
  }
  const found = [...routerHistories].reverse().find(item => {
    const routeName = item.name
    if (typeof routeName !== 'string') return false
    // Exclude routes if specified
    if (excludeNames && excludeNames.includes(routeName)) return false
    return examResultPreviusNameMap.includes(routeName)
  })
  return found
}
